/**
 * Created by rxsl-106 on 2017/6/1.
 */
import api from './index';

let exports = {};

// 获取入库单列表
exports.getGoodsInVoucherList = function (params, callback) {// 入库列表查询
    api.post('/goodsStock/goods/in/voucher/list/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getGoodsOutVoucherList = function (params, callback) {// 出库列表查询
    api.post('/goodsStock/goods/out/voucher/list/get')
    .data(params)
    .done(callback)
    .go()
};

// 制作入库单
exports.saveGoodsInVoucher = function (params, callback) {// 保存入库单信息
    api.post('/goodsStock/goods/in/voucher/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 出、入库单 - 申请
exports.applyGoodsIoVoucher = function (data, callback) {
    api.post('/goodsStock/goods/io/voucher/apply/do')
    .data(data)
    .done(callback)
    .go();
};

// 更新出入库单信息
exports.updateGoodsOutVoucher = function (params, callback) {// 更新出库单信息
    api.post('/goodsStock/goods/out/voucher/update/do')
    .data(params)
    .done(callback)
    .go();
};

// 删除出入库单信息
exports.deleteGoodsIoVoucher = function (params, callback) {// 删除出入库单信息
    api.post('/goodsStock/goods/io/voucher/delete/do')
    .data(params)
    .done(callback)
    .go();
};

// 审核出入库单信息
exports.auditGoodsIoVoucher = function (params, callback) {// 审核出入库单信息
    api.post('/goodsStock/goods/io/voucher/audit/do')
    .data(params)
    .done(callback)
    .go();
};

//=====================出库单操作========================

exports.saveGoodsOutVoucher = function (params, callback) {// 保存出库单信息
    api.post('/goodsStock/goods/out/voucher/save/do')
    .data(params)
    .done(callback)
    .go()
};

//=================仓库操作===================

exports.getWarehouseList = function (params, callback) {// 获取仓库列表
    api.post('/goodsStock/goods/warehouse/list/get')
    .data(params)
    .done(callback)
    .go()
};

exports.getGoodsWarehouse = function (params, callback) {// 获取仓库
    api.post('/goodsStock/goods/warehouse/get')
    .data(params)
    .done(callback)
    .go()
};

exports.saveGoodsWarehouse = function (params, callback) {// 添加仓库
    api.post('/goodsStock/goods/warehouse/save/do')
    .data(params)
    .done(callback)
    .go()
};

exports.updateGoodsWarehouse = function (params, callback) {// 更新仓库
    api.post('/goodsStock/warehouse/update/do')
    .data(params)
    .done(callback)
    .go()
};

exports.deleteGoodsWarehouse = function (params, callback) {// 删除仓库
    api.post('/goodsStock/goods/warehouse/delete/do')
    .data(params)
    .done(callback)
    .go()
};

exports.updateGoodsWarehouseDefaulted = function (params, callback) {// 设置为默认仓库
    api.post('/goodsStock/goods/warehouse/defaulted/update/do')
    .data(params)
    .done(callback)
    .go()
};

//========================== 库存管理 ============================================

//获取库存列表
exports.getGoodsStockList = function (data, callback) {// 库存列表查询
    api.post('/goodsStock/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getGoodsInVoucherInfo = function (params, callback) {// 获取入库单信息
    api.post('/goodsStock/goods/in/voucher/info/get/')
    .data(params)
    .done(callback)
    .go();
};

//获取库存信息
exports.getGoodsStockByWarehouseIdAndSkuId = function (data, callback) {// 获取商品库存
    api.post('/goodsStock/get/by/warehouseId/and/skuId')
    .data(data)
    .done(callback)
    .go();
};

//修改库存信息
exports.updateGoodsStockStockValve = function (data, callback) {// 修改库存预警值
    api.post('/goodsStock/stockValve/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getGoodsStockPreviewList = function (data, callback) {// 预览下载信息
    api.post('/goodsStock/preview/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.downLoadGoodsStockList = function (data, callback) {// 下载信息
    api.post('/goodsStock/list/downLoad/do')
    .data(data)
    .done(callback)
    .go();
};

exports.upLoadGoodsStockList = function (data, callback) {// 库存盘点上传
    api.post('/goodsStock/list/upload/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateGoodsWarehouseLocked = function (data, callback) {// 锁定/解锁仓库
    api.post('/goodsStock/goods/warehouse/locked/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getGoodsIoRecordList = function (data, callback) {// 出入库记录查询
    api.post('/goodsStock/goods/io/record/list/get')
    .data(data)
    .done(callback)
    .go();
};

//========================== 调拨管理 ============================================

//保存调拨单信息
exports.saveGoodsTransVoucher = function (data, callback) {// 保存调拨单信息
    api.post('/goodsStock/goods/trans/voucher/save/do')
    .data(data)
    .done(callback)
    .go();
};
//查询调拨单
exports.getGoodsTransVoucherList = function (data, callback) {// 调拨列表查询
    api.post('/goodsStock/goods/trans/voucher/list/get')
    .data(data)
    .done(callback)
    .go();
};
//查看调拨单
exports.getGoodsTransVoucherInfo = function (data, callback) {// 查看调拨单信息
    api.get('/goodsStock/goods/trans/voucher/info/get')
    .data(data)
    .done(callback)
    .go();
};
//审核调拨单
exports.auditGoodsTransVoucher = function (data, callback) {// 审核调拨单信息
    api.post('/goodsStock/goods/trans/voucher/audit/do')
    .data(data)
    .done(callback)
    .go();
};
//删除调拨单信息
exports.deleteGoodsTransVoucher = function (data, callback) {// 删除调拨单信息
    api.post('/goodsStock/goods/trans/voucher/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// 更新调拨单信息
exports.updateGoodsTransVoucher = function (params, callback) {// 更新调拨单信息
    api.post('/goodsStock/goods/trans/voucher/update/do')
    .data(params)
    .done(callback)
    .go();
};

export default exports;


//////////////////
// WEBPACK FOOTER
// ./src/api/goodsStock.js
// module id = 15
// module chunks = 1